<div role="document" class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
            <h5 class="modal-title">{{title}}</h5>
        </div>
        <div class="modal-body">
            <div class=" row">
                <span class="col">
                    <textarea [(ngModel)]="message" type="text" class="form-control" id="message" row="10" name="message"></textarea>
                </span>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-indigo" (click)="validate()">Valider</button>
            <button type="button" class="btn btn-secondary"
                    data-dismiss="modal" (click)="activeModal.close('Close click')">Annuler
            </button>
        </div>
    </div>
  </div>
